/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const LockSvg = () => (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="#CAC2C2"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.34168 4.71755H8.11406V3.65223C8.11406 1.68184 6.55043 0.0358563 4.59607 0.000720006C4.54266 -0.000240002 4.43596 -0.000240002 4.38258 0.000720006C2.42817 0.0358563 0.86456 1.68184 0.86456 3.65223V4.71755H0.636918C0.286131 4.71755 0 5.07952 0 5.52658V10.8698C0 11.3163 0.286131 11.6817 0.636942 11.6817H8.34168C8.69247 11.6817 8.97862 11.3163 8.97862 10.8698V5.52658C8.97862 5.07955 8.69249 4.71755 8.34168 4.71755ZM5.21114 8.19276V9.80728C5.21114 9.99215 5.05637 10.1486 4.87135 10.1486H4.10732C3.92228 10.1486 3.76751 9.99215 3.76751 9.80728V8.19276C3.58806 8.01612 3.48358 7.77187 3.48358 7.50167C3.48358 6.98965 3.87937 6.54968 4.38261 6.52935C4.43594 6.52719 4.54276 6.52719 4.59609 6.52935C5.09933 6.54968 5.49511 6.98965 5.49511 7.50167C5.49506 7.77187 5.39059 8.01612 5.21114 8.19276ZM6.61381 4.71755H4.59607H4.38258H2.36484V3.65223C2.36484 2.4785 3.3187 1.50801 4.48931 1.50801C5.65992 1.50801 6.61384 2.4785 6.61384 3.65223V4.71755H6.61381Z"
      fill="#CAC2C2"
    />
  </svg>
)

const LockIcon = (props) => <Icon component={LockSvg} {...props} />

export { LockIcon }
